module.exports = __webpack_public_path__ + "img/daili.0f973081.jpg";